const thaiTranslationContent = () => {
  return {
    copy: {
      comma: {
        gpcr: {
          dayOne: 'ศุกร์, 15 พ.ย.',
          dayTwo: 'เสาร์, 16 พ.ย.',
          dayThree: 'อาทิตย์, 17 พ.ย.',
        },
      },
      preSignInPage: {
        firstScreen: `<div class="px-[24px]">\
              <div class="text-center font-aktiv-grotesk font-semibold text-[24px] md:text-[32px] leading-[32px] md:leading-[40px]">ยินดีต้อนรับสู่แอป</div>\
                <div class="flex flex-row justify-center mx-auto items-end">
                  <img src="/assets/images/generations-app.svg" class="w-[190px] md:w-[258px]"/>
                </div>
              <img src="/assets/images/presignin/pre-signin-page-1.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px]">\
                การสร้างสาวก GenerationS เพื่อสร้าง \
                <span class="whitespace-nowrap md:whitespace-auto">Strong Church</span>\
              </div>\
            </div>`,
        secondScreen: `<div class="pt-[8px] px-[24px]">\
              <div class="w-[90vw] md:w-[432px] text-center font-aktiv-grotesk font-semibold text-[20px] md:text-[32px] leading-[32px] md:leading-[40px] mx-auto">\
                ถึงเวลาที่จะทำให้คริสตจักรของเรา \
                <อ่อนวัย> และ <แข็งแกร่งขึ้น>!\
              </div>\
              <img src="/assets/images/presignin/pre-signin-page-2.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                ใช้แอปนี้เพื่อติดตามข่าวสารล่าสุดของการประชุม\
              </div>\
            </div>`,
        thirdScreen: `<div class="pt-[8px] px-[24px]">\
              <div class="w-[90vw] md:w-[432px] mx-auto text-center font-aktiv-grotesk font-semibold text-[24px] md:text-[32px] leading-[28px] md:leading-[40px] mx-auto">\
                มันไม่ได้จบลงแค่ที่การประชุม…\
              </div>\
              <img src="/assets/images/presignin/pre-signin-page-3.png" class="w-auto h-[40vh] md:py-[40px] mx-auto" style="padding-top: 3vh; padding-bottom: 2vh;" />\
              <div class="text-white w-[90vw] md:w-auto mx-auto text-center font-aktiv-grotesk-medium text-[20px] md:text-[28px] leading-[28px] md:leading-[32px] mx-auto">\
                เข้าถึงทรัพยากรพิเศษของ GenerationS และ Strong Church ได้ต่อเนื่องผ่านแอปนี้!\
              </div>\
            </div>\
            </div>`,
        nextButton: 'ถัดไป',
        loginButton: 'ลงชื่อเข้าใช้',
      },
      homePage: {
        profileDropdown: {
          profile: 'โปรไฟล์',
          language: 'ภาษา',
          conference: 'การประชุม',
          logout: 'ออกจากระบบ',
        },
        conferenceType: {
          title: 'การประชุม',
          gpcr: {
            name: 'GenerationS Pastors Conference Regional',
          },
          gpc: {
            name: 'GenerationS Pastors Conference',
          },
          gic: {
            name: 'GenerationS Implementation Community',
          },
        },
        mainLayout: {
          topNav: {
            experiences: 'ประสบการณ์',
            photoDrop: 'PhotoDrop',
            updates: 'อัปเดต',
          },
          scheduleSection: {
            title: 'ตารางเวลา',
            schedulePanel: {
              endOfDay: 'สิ้นสุดวันที่ { day }',
              tillNextTime: 'แล้วพบกันใหม่',
              seeYouTomorrow: 'เจอกันพรุ่งนี้',
              seeYouNextYear: 'เจอกันในปี 2025',
              viewSessionResources: `ต้องการดูทรัพยากรการประชุมหรือไม่?<br />ไปที่`,
              viewSessionResourcesPage: 'หน้าทรัพยากร เลย',
              seeYouSoonText: 'เราดีใจที่คุณมาร่วมกับเรา! แล้วเจอกันใหม่เร็ว ๆ นี้ 🤩',
              cantWaitToSeeYou: 'สวัสดี! เราแทบรอไม่ไหวที่จะได้เจอคุณเร็ว ๆ นี้',
              // applyNow: "สมัครตอนนี้",
              happeningNow: 'Happening now ',
              goToScheduleButton: 'ไปที่ตารางเวลา',
              viewScheduleButton: 'ดูตารางเวลา',
              viewNextDayScheduleButton: 'ดูตารางเวลาของวันถัดไป',
            },
          },
          registration: {
            bannerName: 'registration.png',
          },
          worshipSongs: {
            availableOnYoutube: 'รับชมได้บน YouTube',
            titleImgUrl: '../../../public/assets/images/home/playlist-th.svg',
          },
          kickOffSection: {
            title: `<p class="text-[32px] text-left leading-[40px] text-blue font-aktiv-grotesk-medium pb-4">
                          ก่อนที่เราจะเริ่ม<br class="hidden lg:block"/>...
                        </p>`,
            description: `<p class="text-[16px] text-left lg:w-[320px] mx-auto leading-[24px] text-blue pb-5 font-aktiv-grotesk-regular">
                                ดูวิดีโอสั้นนี้เพื่อรับภาพรวมเกี่ยวกับ GenerationS<br /> คุณจะพร้อมเต็มที่สำหรับ 3 วันที่จะมาถึง 😊
                              </p>`,
            downloadVideo: 'ดาวน์โหลดวิดีโอ',
            downloadThumbnail:
              'https://cdn.generationsmvmt.com/images/app/gpcr-pre-watch-thumbnail-th.jpg',
            downloadLink:
              'https://cdn.generationsmvmt.com/videos/conference-app/gpcr-pre-watch-th.mp4',
          },
          experiences: {},
          usefulLinks: {
            title: 'ลิงก์ที่เป็นประโยชน์',
            links: {
              gettingAround: 'การเดินทางใน HOGC 🚶🏻‍♂️',
              mapLink: 'https://cdn.generationsmvmt.com/docs/th/HOGC-Map.pdf',
              appGuidedTour: 'ทัวร์แนะนำแอป',
              giving: 'การบริจาค',
              busSchedule: 'ตารางรถรับ-ส่ง',
              busSchedulePdf:
                'https://cdn.generationsmvmt.com/docs/GPCR-2024-Shuttle-Bus-Schedule-TH.pdf',
            },
          },
          appGuidedTour: {
            startTour: 'เริ่มการทัวร์',
            skipTour: 'ข้ามการทัวร์',
            skipButton: 'ข้าม',
            backButton: 'กลับ',
            nextButton: 'ถัดไป',
            endButton: 'สิ้นสุด',
            stepPill: {
              stepText: 'ขั้นตอนที่',
              ofText: 'จาก',
            },
            homeTourTextStep0SCS: `
                <div>
                    <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                    <br>
                    <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 28px; font-weight: 500; line-height: 28px;">ยินดีต้อนรับสู่</div>
                    <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                    <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">แอปการประชุมสำหรับศิษยาภิบาล GenerationS ช่วยให้คุณดูตารางเวลาของคุณ เข้าถึงสื่อการประชุม และปรับแต่งประสบการณ์ต่างๆ</div>
                    <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">มาเริ่มการทัวร์สั้นๆ กันเถอะ</div>
                </div>
              `,
            homeTourTextStep0GC: `
                <div>
                    <img src="../../../assets/images/guided-tour/HOGC_SG.svg" alt="HOGC" />
                    <br>
                    <div style="text-align:center; margin-left:auto; margin-right:auto; color:#231F20; font-size: 28px; font-weight: 500; line-height: 28px;">ยินดีต้อนรับสู่</div>
                    <img style="padding-bottom:18px;" src="../../../assets/images/gpcr/gpcr-2024-logo-dark.png" alt="Generations" />
                    <div style="padding-bottom:12px; text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">แอปการประชุมสำหรับศิษยาภิบาล GenerationS ช่วยให้คุณดูตารางเวลาของคุณ เข้าถึงสื่อการประชุม และปรับแต่งประสบการณ์ต่างๆ</div>
                    <div style="padding-bottom:24px; text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">มาเริ่มการทัวร์สั้นๆ กันเถอะ</div>
                </div>
              `,
            homeTourTextStep1: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">ตารางเวลา</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ติดตามตารางประจำวันตลอดการประชุม</span> <br>`,
            homeTourTextStep2: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">ประสบการณ์</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ไปดูเบื้องหลังเพื่อเห็น GenerationS และ Strong Church ที่มีชีวิตชีวา คลิกที่นี่เพื่อดูประสบการณ์ที่คุณได้รับมอบหมาย</span> <br>`,
            homeTourTextStep3: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">PhotoDrop</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ตรวจสอบภาพถ่ายการประชุมที่ปรับแต่งเฉพาะของคุณที่นี่ - อัปเดตแบบเรียลไทม์</span> <br>`,
            homeTourTextStep4: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">ก่อนที่เราจะเริ่ม...</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ชมเพื่อค้นหาการเปลี่ยนแปลงทางความคิดที่จะเริ่มสร้าง GenerationS และโบสถ์ที่แข็งแกร่ง</span> <br>`,
            homeTourTextStep5: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">โปรไฟล์และการตั้งค่า</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">คุณสามารถอัปเดตรายละเอียดการติดต่อของคุณที่นี่และเลือกภาษาที่คุณต้องการ</span> <br> <br>`,
            scheduleTourStep1: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">ตารางเวลา</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">เข้าถึงตารางเวลาการประชุมทั้งหมด</span>`,
            scheduleTourStep2: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">ตารางเวลา (มุมมองรายวัน)</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ดูเวลาการประชุมและสถานที่ประจำวัน</span>`,
            scheduleTourStep3: `<span style="text-align:left; color:#231F20; font-size: 24px; line-height: 24px;">สื่อการประชุม</span> <br> <br>
                    <span style="text-align:left; color:#231F20; font-weight: 400; font-size: 20px; line-height: 24px;">ตรวจสอบ 'ดูสื่อการประชุม' และคุณพร้อมสำหรับการประชุมแล้ว</span>`,
          },
        },
      },
      languagePage: {
        title: 'ภาษา',
        english: 'ภาษาอังกฤษ',
        chinese: 'ภาษาจีนตัวย่อ',
        thai: 'ภาษาไทย',
      },
      settingsPage: {
        title: 'การตั้งค่า',
        general: {
          title: 'ทั่วไป',
          language: 'ภาษา',
          conferenceSelector: 'เลือกการประชุม',
        },
        support: {
          title: 'การช่วยเหลือ',
          enquiry: 'สอบถาม',
          appGuidedTour: 'แนะนำการใช้งานแอป',
          privacyPolicy: 'นโยบายความเป็นส่วนตัว',
          termsOfUse: 'ข้อกำหนดการใช้งาน',
        },
        logout: 'ออกจากระบบ',
      },
      profilePage: {
        showQr: 'แสดง QR',
        personalQr: 'QR ส่วนตัว',
        editProfile: 'แก้ไขโปรไฟล์',
        addImage: 'ตั้งรูปภาพใหม่',
        displayName: `ชื่อที่แสดง (จำเป็น)`,
        emptyName: 'บอกชื่อของคุณให้เราทราบ',
        organization: 'โบสถ์ / องค์กร',
        title: 'ตำแหน่ง',
        addEmail: 'เพิ่มอีเมล',
        addSocials: 'เพิ่มโซเชียล',
        editEmail: 'แก้ไขอีเมล',
        editSocials: 'แก้ไขโซเชียล',
        email: 'อีเมล',
        showMyEmail: 'แสดงอีเมลของฉัน',
        accountLoginEmail: 'อีเมลสำหรับเข้าสู่ระบบบัญชี',
        socials: 'โซเชียล',
        socialMedia: {
          addSocialsTitle: 'เพิ่มโซเชียล',
          addInstagram: 'เพิ่ม Instagram',
          addFacebook: 'เพิ่ม Facebook',
          addX: 'เพิ่ม X',
          addLinkedIn: 'เพิ่ม LinkedIn',
        },
        saveChanges: 'บันทึกการเปลี่ยนแปลง',
        unsavedTitle: 'ยกเลิกการเปลี่ยนแปลง?',
        unsavedBody: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก หากออกตอนนี้ ข้อมูลจะสูญหาย',
        unsavedKeepEditing: 'แก้ไขต่อ',
        unsavedDiscard: 'ยกเลิกการเปลี่ยนแปลง',
      },
      announcementPage: {
        title: 'อัปเดตล่าสุด',
        announcementCard: {
          newLabel: 'ใหม่',
          today: 'วันนี้, ',
        },
      },
      resourcesPage: {
        title: 'ทรัพยากร',
        filterBy: 'กรองตาม',
        filterSection: {
          topics: 'หัวข้อ',
          sessions: 'การประชุม',
          day: 'วันที่{ i }: ',
          all: 'ทั้งหมด',
          session: 'การประชุม',
        },
        searchContent: {
          searchingStringText: `ผลลัพธ์การค้นหาสำหรับ "{searchTerm}"`,
          noResourcesSearchText: `การค้นหาของคุณสำหรับ "{searchTerm}" ไม่มีผลลัพธ์`,
          noOfResourcesFound: `พบทรัพยากร {count} รายการ`,
        },
        videoPage: {
          videoChapters: 'บทในวิดีโอ',
          yellowTag: {
            exclusive: 'พิเศษ',
            audioOnly: 'เฉพาะเสียง',
          },
          shareButton: 'แชร์',
        },
        description:
          'ยินดีต้อนรับสู่ศูนย์รวมทรัพยากรของ GenerationS และ Strong Church สำหรับคุณ ใช้คำเทศนา วิดีโอ และเครื่องมือต่าง ๆ เหล่านี้เพื่อทำให้โบสถ์ของคุณเติบโตขึ้นอย่างเยาว์วัยและแข็งแกร่งขึ้น',
        searchBar: 'ค้นหา',
        resourceSearch: {
          bookSection: {
            header: 'หนังสือ',
          },
          quotesSection: {
            header: 'คำคม',
          },
          suggestionSection: {
            header: 'คุณอาจสนใจใน...',
          },
          bookmarksSection: {
            header: 'รายการของฉัน',
          },
        },
        backToTopSection: {
          otherContentText: 'สนใจทรัพยากรอื่น ๆ หรือไม่',
          backToTop: 'กลับไปด้านบน',
        },
      },
      sessionResourcesPage: {
        accessLiveInterpretation: 'การแปลสด',
        sessionResourcesheader: 'สื่อการประชุม',
        assets: {
          toolsHeader: 'เครื่องมือ',
          questionsHeader: 'คำถามเกี่ยวกับเวลาสนทนา',
          linksHeader: 'ทรัพยากรที่เกี่ยวข้อง',
        },
      },
      experiencePage: {
        title: 'ประสบการณ์',
        description: 'ไปเบื้องหลังและดูหลักการของ GenerationS และ Strong Church ที่มีชีวิตขึ้นมา',
        note: '📢ค้นหาว่าคุณจะเข้าร่วมประสบการณ์ไหน',
        experienceList: {
          title: 'ผู้เข้าร่วมแต่ละคนจะเข้าร่วม 1 ใน 4 ประสบการณ์ระหว่าง GPCR:',
          exp1: 'ประสบการณ์การประชุมอธิษฐาน',
          exp2: 'บรีฟภายหลังจากการรับใช้',
          exp3: 'ประสบการณ์กลุ่มย่อย',
          exp4: 'คืนแห่งความฝันและเรื่องราว',
          note: '📢 ค้นหาว่าคุณจะเข้าร่วมประสบการณ์ใดภายใน{date}',
        },
        allocationPanel: {
          title: 'คุณจะเข้าร่วม',
          protipTitle: '💡เคล็ดลับ:',
          protipHeader: 'ใช้ประโยชน์สูงสุดจากประสบการณ์ด้วยคำถามในการสะท้อนความคิด:',
          protipQuestion1: 'ฉันสามารถนำอะไรไปใช้ในโบสถ์ของฉันได้บ้าง',
          protipQuestion2: 'สิ่งนี้สามารถนำไปใช้ในบริบทของโบสถ์ของฉันได้อย่างไร',
          viewMapButton: 'ดูแผนที่',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/th/HOGC-Map.pdf',
          viewFloorplanButton: 'ดูแผนผังชั้น',
          viewFloorplanButtonLink:
            'https://cdn.generationsmvmt.com/docs/th/GPCR-Dream-and-Stories-Night-Floorplan.pdf',
        },
        carousel: {
          title: 'เรียนรู้เพิ่มเติมเกี่ยวกับประสบการณ์ทั้ง {count}',
          viewDetailsButton: 'ดูรายละเอียด',
        },
      },
      schedulePage: {
        scheduleButton: 'ตารางเวลา 3 วัน',
        schedule: 'https://cdn.generationsmvmt.com/docs/GPCR-2024-Schedule-TH.pdf',
        dayOne: {
          day: 'ศุกร์',
          dayNum: '15',
          month: 'พ.ย.',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">สวัสดี</div>
              📣 ทานอาหารเช้าก่อนมา!<br class="md:hidden"> อย่าลืมนำหูฟังและเสื้อแจ็คเก็ตมาด้วยนะ<br>`,
        },
        dayTwo: {
          day: 'เสาร์',
          dayNum: '16',
          month: 'พ.ย.',
          announcement: `<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">สุดสัปดาห์แล้ว</div>
              📣 ทานอะไรก่อนมาด้วยนะ<br>`,
        },
        dayThree: {
          day: 'อาทิตย์',
          dayNum: '17',
          month: 'พ.ย.',
          announcement:
            '<div class="text-[16px] leading-[24px] font-aktiv-grotesk-trial text-black">วันสุดท้ายของเราจะเต็มไปด้วยเซสชันที่ทรงพลัง</div>📣 ทานอาหารเช้าก่อนมานะ',
        },
        eventsCard: {
          accessLiveInterpretation: 'การแปลสด',
          seeSessionResources: 'การประชุม',
          viewMapButtonLink: 'https://cdn.generationsmvmt.com/docs/th/HOGC-Map.pdf',
        },
        // experienceHeader: "ประสบการณ์",
        checkAllocation: 'ตรวจสอบการจัดสรร',
        backToTop: 'กลับไปด้านบน',
      },
      photoDropPage: {
        photoDropActionBar: {
          myQR: 'ส่วนตัวQR',
          select: 'เลือก',
          cancel: 'ยกเลิก',
          download: 'ดาวน์โหลด',
          downloading: 'กำลังดาวน์โหลด',
          noOfSelectedPhotosText: 'เลือกรูปภาพ { count } รูป',
        },
        myPhotosTab: {
          tabName: 'รูปภาพของฉัน',
        },
        forEveryoneTab: {
          tabName: 'สำหรับทุกคน',
          videosTab: 'วิดีโอ',
          dayTab: 'วันที่{ i }',
          viewMore: 'ดูเพิ่มเติม',
        },
        personalTab: {
          tabName: 'ส่วนตัว',
          subtitle: 'ชวนเพื่อน ชวนช่างภาพ แล้วเริ่มถ่ายรูปกันเลย',
          qrCodeModal: {
            subtitle: 'ให้รูปภาพของคุณถูกส่งตรงถึงคุณ',
            instructions: {
              one: 'แสดง QR Code นี้ให้ช่างภาพ HOGC คนใดที่สวมเสื้อ “PhotoDrop” สีขาว 👕📸',
              two: 'ชวนเพื่อนของคุณ มาถ่ายรูป และกลับมาที่นี่เพื่อดูรูป',
            },
          },
        },
        customExperiencesTab: {
          tabName: 'ประสบการณ์ที่กำหนดเอง',
          subtitle: 'รูปภาพจากประสบการณ์ที่คุณเข้าร่วมจะถูกส่งมาที่นี่ 🎁',
        },
        selectButton: 'เลือก',
        downloadModal: {
          header: 'รับลิงก์ดาวน์โหลดทางอีเมล',
          description: 'ลิงก์จะถูกส่งไปยังอีเมลของคุณเพื่อดาวน์โหลดวิดีโอและ/หรือรูปภาพที่เลือก',
          sendToMyEmail: 'ส่งลิงก์ไปยังอีเมลของฉัน',
          cancel: 'ยกเลิก',
        },
      },
      teamPage: {
        title: `<div class="font-aktiv-grotesk-medium mx-auto w-full xl:min-w-[360px] text-center xl:text-left text-[24px] leading-[32px]">
                      สวัสดีจากทีม Global
                    </div>`,
        backRowText: 'แถวหลัง จากซ้ายไปขวา:',
        backRowNames: {
          pastorMartin: 'Pastor Martin Wong',
          blakeGladd: 'Blake Gadd',
          nataschaBruschweiler: 'Natascha Brüschweiler',
          nadineLeong: 'Nadine Leong',
        },
        frontRowText: 'แถวหน้า จากซ้ายไปขวา:',
        frontRowNames: {
          jamieLee: 'Jamie Lee',
          valerieFifi: 'Valerie Fifi',
          christianHonegger: 'Christian Honegger',
          tanJianMing: 'Tan Jian Ming',
        },
        meetTheFullLeadershipTeam: 'พบกับทีมผู้นำทั้งหมด',
      },
      sideBar: {
        home: 'หน้าแรก',
        resources: 'ทรัพยากร',
        schedule: 'ตารางเวลา',
        team: 'ทีม',
        updates: 'อัปเดต',
        termOfUse: 'ข้อกำหนดการใช้งาน',
        privacyPolicy: 'นโยบายความเป็นส่วนตัว',
      },
      bottomNav: {
        home: 'หน้าแรก',
        resources: 'ทรัพยากร',
        schedule: 'ตารางเวลา',
        team: 'ทีม',
        updates: 'อัปเดต',
        more: 'เพิ่มเติม',
      },
      masterLayout: {
        logoutPopup: {
          message: 'คุณต้องการออกจากระบบหรือไม่',
          continue: 'ดำเนินการต่อ',
          cancel: 'ยกเลิก',
        },
        newsLetterModal: {
          header: 'แชร์กับทีมของคุณ',
          description: `กรอกชื่อและอีเมลของพวกเขา<br>เราจะส่งคำเชิญให้แต่ละคนเข้าร่วมแอป GenS`,
          inputNamePlaceholder: 'ชื่อเพื่อนของคุณ',
          inputEmailPlaceholder: 'อีเมลของเพื่อนของคุณ',
          errorMessage: {
            emptyNameInput: 'ต้องระบุชื่อ',
            emptyEmailInput: 'ต้องการอีเมล',
            notValidEmail: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
            errorOnSubmit: 'เกิดข้อผิดพลาดขณะส่งแบบฟอร์ม โปรดลองอีกครั้งในภายหลัง',
          },
          subscribe: 'ส่งคำเชิญทางอีเมล',
          sent: 'Sent',
        },
        filterModal: {
          resetFilters: 'รีเซ็ต',
          applyFilters: 'ใช้ตัวกรอง',
          noItems: 'ไม่มีรายการ',
        },
      },
    },
  };
};

export default thaiTranslationContent;
